import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import Button from "../../AdminModule/Dashboard/AdminDashboard/Button";
import "./styles.scss";
import axios from "axios";
import {
  MY_MENTORSHIP_LIST,
  MY_MENTORS_LIST,
} from "../constants/ApplicationUrl";
import api from "../../common/dependencies/utils/Api";

import hashImage from "../../../assets/images/hashImage.jpeg";
import profile from "../../../assets/svg/dashboard/profile-iconRound.svg";
import ModalRequirement from "../../AdminModule/Dashboard/StartupDashboard/MyRequests/Modal/modal";
import { deleteSessionData } from "../../AdminModule/Dashboard/StartupDashboard/dependencies/action";
import * as moment from "moment";
import Pagination from "react-js-pagination";
import * as CryptoJS from "crypto-js";
import { PROFILE_KEY } from "../constants/actionConstants";

function CohortSummayModal2(props) {
  class AesUtil {
    constructor(keySize, iterationCount) {
      this.keySize = keySize / 32;
      this.iterationCount = iterationCount;
    }
  
    generateKey = function (salt, passPhrase) {
      let key = CryptoJS.PBKDF2(passPhrase, CryptoJS.enc.Hex.parse(salt), {
        keySize: this.keySize,
        iterations: this.iterationCount,
      });
      return key;
    };
  
    encrypt = function (salt, iv, passPhrase, plainText) {
      let key = this.generateKey(salt, passPhrase);
      let encrypted = CryptoJS.AES.encrypt(plainText, key, {
        iv: CryptoJS.enc.Hex.parse(iv),
      });
      return encrypted.ciphertext.toString(CryptoJS.enc.Base64);
    };
  }
  const encryptAES2 = (text, key) => {
    // let iv = CryptoJS.lib.WordArray.random(128 / 8).toString(CryptoJS.enc.Hex);
    // let salt = CryptoJS.lib.WordArray.random(128 / 8).toString(CryptoJS.enc.Hex);
  
    // let aesUtil = new AesUtil(128, 1000);
    // let ciphertext = aesUtil.encrypt(salt, iv, key, text);
  
    // let aesText = iv + "::" + salt + "::" + ciphertext;
    
    return btoa(text);
  };
  const [modalOpen2, setModalOpen2] = useState(false);
  const [modalData2, setModalData2] = useState();
  const [modalPopup2, setModalPopup2] = useState();
  const [modalPopup3, setModalPopup3] = useState([]);
  const [activePage, setActivePage] = useState(1);
  const [mentorPaginate, setMentorPaginate] = useState();
  const [startupPaginate, setStartupPaginate] = useState();
  const currentRoute = window.location.href;
  let sample;
  sample = currentRoute.slice(0, currentRoute.lastIndexOf("/"));
  const { mentorShipId, fromModule, modalVisibility } = props;
  const [requestJsonArr, setRequestJsonArr] = useState([]);
  const handleClose = () => {
    props.setModalVisibility(false);
    setModalPopup2([]);
    setActivePage(1);
    setRequestJsonArr([]);
  };

  const ViewProfile = (item, id) => {
    let reRoute = window.open(sample + `/mentor-profile/${encryptAES2(item,PROFILE_KEY)}`, "_blank");
    // let reRoute = window.open(sample + `/mentor-profile/${item}`, "_blank");
    reRoute.id = item;
  };
  const redirectProfile = (dpiitNo) => {
    let reRoute = window.open(sample + "/startup-profile", "_blank");
    reRoute.id = dpiitNo;
  };
  useEffect(() => {
    if (fromModule === "Mentor") getMentorsList();
    else getStartupList();
  }, []);

  const getStartupList = () => {
    // axios({
    //   url: MY_MENTORSHIP_LIST,
    //   method: "POST",
    //   data: {
    //     mentorId: mentorShipId,
    //     pageFilter: {
    //       currentPage: 0,
    //       includeCount: true,
    //       pageSize: 5,
    //       sortField: "name",
    //       sortOrder: "ASC",
    //     },
    //   },
    // })
    api
      .POST(MY_MENTORSHIP_LIST, {
        mentorId: mentorShipId,
        pageFilter: {
          currentPage: 0,
          includeCount: true,
          pageSize: 5,
          sortField: "name",
          sortOrder: "ASC",
        },
      })
      .then((res) => {
        let newData = res?.data?.data;
        setStartupPaginate(res?.data?.paginate);
        let item = [];
        newData.forEach((element) => {
          let sample = element.startup;
          item.push(element);
          setModalPopup2((prevState) => [...prevState, sample]);
        });
        setModalPopup3(item);
        props.closeLoader();
      })
      .catch((err) => {
        props.closeLoader();
      });
  };

  const getMentorsList = () => {
    let params = {
      requestedBy: mentorShipId,
    };
    // axios({
    //   url: MY_MENTORS_LIST,
    //   method: "POST",
    //   data: {
    //     requestedBy: mentorShipId,
    //     pageFilter: {
    //       currentPage: 0,
    //       includeCount: true,
    //       pageSize: 5,
    //       sortField: "name",
    //       sortOrder: "ASC",
    //     },
    //   },
    // })
    api
      .POST(MY_MENTORS_LIST, {
        requestedBy: mentorShipId,
        pageFilter: {
          currentPage: 0,
          includeCount: true,
          pageSize: 5,
          sortField: "name",
          sortOrder: "ASC",
        },
      })
      .then((res) => {
        setModalPopup2(res?.data?.data);
        setMentorPaginate(res?.data?.paginate);
        props.closeLoader();
      })
      .catch((err) => {
        props.closeLoader();
      });
  };
  useEffect(() => {
    let reqJson;
    let data = [];
    if (modalPopup3 && props.fromPage && props.fromPage === "mentorships") {
      modalPopup3.forEach((item) => {
        reqJson = {
          industry: item.mentorRequest.requestJson.industry,
          sub_industry: item.mentorRequest.requestJson.sub_industry,
          function: item.mentorRequest.requestJson.function,
          sub_function: item.mentorRequest.requestJson.sub_function,
          stage: item.mentorRequest.requestJson.stage,
          state: item.mentorRequest.requestJson.state,
          purpose: item.mentorRequest.requestJson.purpose,
        };
        data.push(reqJson);
        setRequestJsonArr(data);
      });
    }
  }, [modalPopup2]);

  const handlePageChangeMentor = (pageNumber) => {
    setActivePage(pageNumber);
    // axios({
    //   url: MY_MENTORS_LIST,
    //   method: "POST",
    //   data: {
    //     requestedBy: mentorShipId,
    //     pageFilter: {
    //       currentPage: pageNumber - 1,
    //       includeCount: true,
    //       pageSize: 5,
    //       sortField: "name",
    //       sortOrder: "ASC",
    //     },
    //   },
    // })
    api
      .POST(MY_MENTORS_LIST, {
        requestedBy: mentorShipId,
        pageFilter: {
          currentPage: pageNumber - 1,
          includeCount: true,
          pageSize: 5,
          sortField: "name",
          sortOrder: "ASC",
        },
      })
      .then((res) => {
        setModalPopup2(res?.data?.data);
        setMentorPaginate(res?.data?.paginate);
        props.closeLoader();
      })
      .catch((err) => {
        props.closeLoader();
      });
  };
  const handlePageChange = (pageNumber) => {
    setModalPopup2("");
    setActivePage(pageNumber);
    // axios({
    //   url: MY_MENTORSHIP_LIST,
    //   method: "POST",
    //   data: {
    //     mentorId: mentorShipId,
    //     pageFilter: {
    //       currentPage: pageNumber - 1,
    //       includeCount: true,
    //       pageSize: 5,
    //       sortField: "name",
    //       sortOrder: "ASC",
    //     },
    //   },
    // })
    api
      .POST(MY_MENTORSHIP_LIST, {
        mentorId: mentorShipId,
        pageFilter: {
          currentPage: pageNumber - 1,
          includeCount: true,
          pageSize: 5,
          sortField: "name",
          sortOrder: "ASC",
        },
      })
      .then((res) => {
        let newData = res?.data?.data;
        setStartupPaginate(res?.data?.paginate);
        newData.forEach((element) => {
          let sample = element.startup;
          setModalPopup2((prevState) => [...prevState, sample]);
        });

        props.closeLoader();
      })
      .catch((err) => {
        props.closeLoader();
      });
  };

  useEffect(() => {
    setModalPopup2("");
    if (fromModule === "Startup") getStartupList();
    else getMentorsList();
  }, [modalVisibility]);
  return (
    <>
      <div className="modal-dialog modal-dialog-centered ">
        <Modal
          size="lg"
          show={props?.modalVisibility}
          onHide={() => {
            props.setModalVisibility(false);
            setActivePage(1);
            setModalPopup2([]);
            setRequestJsonArr([]);
          }}
          aria-labelledby="example-modal-sizes-title-lg"
          style={{ borderRadius: "7px" }}
        >
          <Modal.Header
            className="d-flex "
            style={{ justifyContent: "space-between" }}
          >
            <Modal.Title className="modalHeading">
              {props.fromModule === "Mentor" ? "MENTORS" : "STARTUPS"} ENGAGED
            </Modal.Title>
            <div className="newuserTooltip">
              <button
                type="button"
                className="btn-close"
                aria-label="Close"
                onClick={handleClose}
              />
              <span
                className="tooltiptext  close-window"
                style={{ left: "-130px", top: "2px", width: "130px" }}
              >
                Close Window
              </span>
            </div>
          </Modal.Header>
          <Modal.Body>
            <div className="session-detailsModal">
              {props.fromModule === "Mentor" ? (
                <div className="totalTableCount" style={{ right: "1.3rem" }}>
                  Total Mentors Found : {mentorPaginate?.totalElements} &lt;{" "}
                  {mentorPaginate?.currentPage} of {mentorPaginate?.numPages}{" "}
                  &gt;
                </div>
              ) : (
                <div className="totalTableCount" style={{ right: "1.3rem" }}>
                  Total Startups Found : {startupPaginate?.totalElements} &lt;{" "}
                  {startupPaginate?.currentPage} of {startupPaginate?.numPages}{" "}
                  &gt;
                </div>
              )}
              <div className="col-md-10 session-detailwhole startupsengagedmodalpopup">
                <table
                  className="cohortSummaryTable strtupengagedsummarytblmbl"
                  // style={{ minWidth: "53.5rem" }}
                >
                  <th className="tableJustify fixColumbnWidth4 mblviewtdheader">
                    NO
                  </th>
                  <th
                    colspan="2"
                    style={
                      props.fromModule && props.fromModule === "Startup"
                        ? { minWidth: "29.9rem", maxWidth: "30rem" }
                        : {}
                    }
                    className="mblviewtdheader"
                  >
                    {props.fromModule === "Mentor" ? "MENTOR" : "STARTUP"}
                  </th>
                  <th className="mblviewtdheader">
                    {props.fromModule === "Mentor" ? "MENTOR ID" : "STARTUP ID"}
                  </th>
                  <th
                    className="mblviewtdheader"
                    style={
                      props.fromModule && props.fromModule === "Mentor"
                        ? { minWidth: "15.9rem", maxWidth: "16rem" }
                        : {}
                    }
                  >
                    {props.fromModule === "Mentor"
                      ? "PURPOSE OF REQUEST"
                      : "MENTORSHIP REQUIREMENT"}
                  </th>
                  {modalPopup2 &&
                    modalPopup2?.length > 0 &&
                    modalPopup2.map((item, index) => (
                      <tbody>
                        <tr style={{ borderBottom: "1px solid lightgrey" }}>
                          {props.fromModule === "Mentor" ? (
                            <td className="srnotdstrtupenged">
                              <div
                                style={{
                                  display: "flex",
                                  justifyContent: "left",
                                  // alignItems: "center",
                                  // height: "100px",
                                }}
                              >
                                {index +
                                  1 +
                                  5 * (mentorPaginate?.currentPage - 1)}
                              </div>
                            </td>
                          ) : (
                            <td className="srnotdstrtupenged">
                              <div
                                style={{
                                  display: "flex",
                                  justifyContent: "left",
                                  // alignItems: "center",
                                  // height: "100px",
                                }}
                              >
                                {index +
                                  1 +
                                  5 * (startupPaginate?.currentPage - 1)}
                              </div>
                            </td>
                          )}
                          <td
                            style={{
                              display: "flex",
                              // justifyContent: "center",
                              border: "none",
                            }}
                            className="srtuptdstrtupenged"
                          >
                            {props.fromModule === "Startup" ? (
                              <div
                                className="newuserTooltip"
                                style={{
                                  width: "100px",
                                  height: "100px",
                                  maxWidth: "none",
                                  objectFit: "contain",
                                }}
                              >
                                <img
                                  src={
                                    item?.logo !== undefined &&
                                    item?.logo !== null &&
                                    item?.logo !== undefined &&
                                    item?.logo !== ""
                                      ? item?.logo
                                      : item?.startupImage !== undefined &&
                                        item?.startupImage !== null &&
                                        item?.startupImage !== undefined &&
                                        item?.startupImage !== ""
                                      ? item?.startupImage
                                      : hashImage
                                  }
                                  className="sidebar-dashboard-icon2 strtuppicstrtupengaged"
                                  style={{
                                    width: "100%",
                                    height: "100%",
                                    objectFit: "contain",
                                    cursor: "pointer",
                                    // minWidth: "7rem",
                                    position: "relative",
                                    // left: "2.5rem",
                                    height: "6rem",
                                  }}
                                  onClick={() => {
                                    redirectProfile(item.dippNumber);
                                  }}
                                />
                                <span
                                  className="tooltiptext tooltip-bottom "
                                  style={{
                                    width: "175px",
                                    left: "4.8rem",
                                    top: "6.2rem",
                                  }}
                                >
                                  View{" "}
                                  {props.fromModule === "Mentor"
                                    ? "Mentor"
                                    : "Startup"}{" "}
                                  Profile
                                </span>
                              </div>
                            ) : (
                              <div
                                className="newuserTooltip"
                                style={{
                                  width: "100px",
                                  height: "100px",
                                  maxWidth: "none",
                                  objectFit: "contain",
                                }}
                              >
                                <img
                                  src={
                                    item?.image !== undefined &&
                                    item?.image !== "" &&
                                    item?.image !== null
                                      ? item?.image
                                      : item?.uploadProfilePic !== undefined &&
                                        item?.uploadProfilePic !== null &&
                                        item?.uploadProfilePic !== undefined &&
                                        item?.uploadProfilePic !== ""
                                      ? item?.uploadProfilePic
                                      : hashImage
                                  }
                                  className="sidebar-dashboard-icon2 strtuppicstrtupengaged"
                                  style={{
                                    width: "100%",
                                    height: "100%",
                                    objectFit: "contain",
                                    cursor: "pointer",
                                    // minWidth: "7rem",
                                    position: "relative",
                                    // left: "2.5rem",
                                    height: "6rem",
                                  }}
                                  onClick={() => {
                                    if (props.fromModule === "Mentor")
                                      if (
                                        item.email &&
                                        item.email !== null &&
                                        item.email !== ""
                                      )
                                        ViewProfile(item?.email, item?.id);
                                      else
                                        ViewProfile(item?.email_id, item?.id);
                                    else if (
                                      props.fromPage &&
                                      props.fromPage == "mentorships"
                                    )
                                      redirectProfile(item.dippNumber);
                                    else redirectProfile(item.dpiitNo);
                                  }}
                                />
                                <span
                                  className="tooltiptext tooltip-bottom "
                                  style={{
                                    width: "175px",
                                    left: "4.8rem",
                                    top: "6.2rem",
                                  }}
                                >
                                  View{" "}
                                  {props.fromModule === "Mentor"
                                    ? "Mentor"
                                    : "Startup"}{" "}
                                  Profile
                                </span>
                              </div>
                            )}
                          </td>
                          <td className="orgnamestrtupengagedmbl">
                            <div className="detartdiv">
                              <div
                                style={{
                                  flexDirection: "row",
                                  display: "flex",
                                  justifyContent: "space-between",
                                  // minWidth: "15.9rem",
                                  // maxWidth: "16rem",
                                }}
                                className="orgnamestrtupengagedmblunderdiv"
                              >
                                <div
                                  style={{
                                    cursor: "pointer",
                                    alignItems: "center",
                                    display: "flex",
                                    minWidth: "200px",
                                  }}
                                >
                                  {props.fromModule === "Mentor" ? (
                                    <div>
                                      <div>{item.applicant_name}</div>
                                      <div className="mt-1">
                                        {item.organization_name}
                                      </div>
                                      <div className="mt-1">{item.city}</div>
                                    </div>
                                  ) : (
                                    item.organization_name
                                  )}
                                </div>
                              </div>
                              <div
                                className="newuserTooltip"
                                onClick={() => {
                                  if (props.fromModule === "Mentor")
                                    if (
                                      item.email &&
                                      item.email !== null &&
                                      item.email !== ""
                                    )
                                      ViewProfile(item?.email, item?.id);
                                    else ViewProfile(item?.email_id, item?.id);
                                  else if (
                                    props.fromPage &&
                                    props.fromPage == "mentorships"
                                  )
                                    redirectProfile(item.dippNumber);
                                  else redirectProfile(item.dpiitNo);
                                }}
                              >
                                <img
                                  src={profile}
                                  style={{
                                    cursor: "pointer",
                                    alignItems: "end",
                                    justifyContent: "center",
                                    width: "40px",
                                    display: "flex",
                                    float: "right",
                                  }}
                                />

                                <span
                                  className="tooltiptext tooltip-bottom "
                                  style={{
                                    left: "16.2rem",
                                    top: "2.9rem",
                                    width: "150px",
                                  }}
                                >
                                  {props.fromModule === "Mentor"
                                    ? "View Mentor Profile"
                                    : "View StartUp Profile"}
                                </span>
                              </div>
                            </div>
                          </td>
                          <td className="strtupidstrtupengagedmbl">
                            {props.fromModule === "Mentor"
                              ? "M" + item?.id?.substring(item?.id?.length - 6)
                              : props.fromModule === "Startup" &&
                                item.id !== undefined &&
                                item.id !== null &&
                                item.id !== ""
                              ? "S" + item?.id?.substring(item?.id?.length - 6)
                              : "S" +
                                item?.startupId?.substring(
                                  item?.startupId?.length - 6
                                )}
                            {}
                          </td>
                          <td className="menreqstrtupengagedmbl">
                            {props.fromModule === "Mentor" ? (
                              ""
                            ) : (
                              <>
                                <div>
                                  {moment(
                                    modalPopup3[index]?.mentorRequest
                                      ?.mentorAcceptDate
                                  ).format("DD/MM/YYYY")}
                                </div>
                                <div>
                                  {moment(
                                    modalPopup3[index]?.mentorRequest
                                      ?.mentorAcceptDate
                                  ).format("hh:mm A")}
                                </div>
                                <div className="newuserTooltip">
                                  <a
                                    onClick={() => {
                                      setModalData2(requestJsonArr[index]);

                                      setModalOpen2(true);
                                    }}
                                    className="color-green"
                                  >
                                    <div>
                                      {"S" +
                                        item?.userId?.substring(
                                          item?.userId?.length - 6
                                        )}
                                    </div>
                                  </a>
                                  <span
                                    className="tooltiptext mentoricon tooltip-bottom"
                                    style={{ width: "16vw", top: "2rem" }}
                                  >
                                    View Mentorship Requirement
                                  </span>
                                </div>
                              </>
                            )}
                            {}
                          </td>
                        </tr>
                      </tbody>
                    ))}
                </table>

                <div className="pagination-box">
                  {props.fromModule === "Mentor"
                    ? mentorPaginate && (
                        <Pagination
                          activePage={activePage}
                          itemsCountPerPage={5}
                          totalItemsCount={mentorPaginate?.totalElements}
                          pageRangeDisplayed={5}
                          onChange={handlePageChangeMentor.bind(this)}
                        />
                      )
                    : startupPaginate && (
                        <Pagination
                          activePage={activePage}
                          itemsCountPerPage={5}
                          totalItemsCount={startupPaginate?.totalElements}
                          pageRangeDisplayed={5}
                          onChange={handlePageChange.bind(this)}
                        />
                      )}
                </div>
                <ModalRequirement
                  modalOpen={modalOpen2}
                  setModalOpen={setModalOpen2}
                  modalData={modalData2}
                />
                {/* */}
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer className="d-flex justify-content-center">
            <div className="newuserTooltip top-btn">
              <Button
                onClick={handleClose}
                text="CLOSE"
                className="modalButton51 doc-upload"
              ></Button>
              <span
                className="tooltiptext   tooltip-bottom"
                style={{
                  top: "65px",
                  left: "50px",
                  width: "130px",
                  height: "25px",
                }}
              >
                Close window
              </span>
            </div>
          </Modal.Footer>
        </Modal>
      </div>
    </>
  );
}

const mapStateToProps = (state) => {
  return {
    getPredefineOptions: state.AdminMentorReducer.getPredefineOptionsList.list,
  };
};

export default connect(mapStateToProps, {
  deleteSessionData,
})(withRouter(CohortSummayModal2));
